export const banner2 = {
  type: "banner", // table, content, setting
  language:[{name:"th",value:true},
    {name:"en",value:false},
    {name:"cn",value:false}],
  th:{
    img:"https://media-exp3.licdn.com/dms/image/C561BAQH4LyFb3wbhTQ/company-background_10000/0/1618029083220?e=2159024400&v=beta&t=8h_EoDvajis_B4NeJcoeX1e9jF6U-Btx0alvvJuSU6w",
    title:"TH",
    url:"https://www.google.com",
   
  },
  en:{
    img:"https://cdn.domestika.org/c_limit,dpr_auto,f_auto,q_auto,w_820/v1583521889/content-items/003/823/159/00.data-color-picker-original-original.png?1583521889",
    title:"EN",
    url:"https://www.google.com",
    
  },
  cn:{
    img:"https://media-exp3.licdn.com/dms/image/C561BAQH4LyFb3wbhTQ/company-background_10000/0/1618029083220?e=2159024400&v=beta&t=8h_EoDvajis_B4NeJcoeX1e9jF6U-Btx0alvvJuSU6w",
    title:"CHINA",
    url:"https://www.google.com",
  
  },
  isPublish:"share",// share|on_schedule
  startDate:"2021-08-08T17:00:00.000Z",
  endDate:"2021-08-12T17:00:00.000Z",
};

export const content = {
  type: "content",
  language:[{name:"th",value:true},{name:"en",value:false},{name:"cn",value:false}],

    th: {
      banner_img: "https://media-exp3.licdn.com/dms/image/C561BAQH4LyFb3wbhTQ/company-background_10000/0/1618029083220?e=2159024400&v=beta&t=8h_EoDvajis_B4NeJcoeX1e9jF6U-Btx0alvvJuSU6w",
      title: "Thai",
      content_link: null,
      text:null,
      sub_content:[]
      
    },
    en: {
      banner_img: "https://media-exp3.licdn.com/dms/image/C561BAQH4LyFb3wbhTQ/company-background_10000/0/1618029083220?e=2159024400&v=beta&t=8h_EoDvajis_B4NeJcoeX1e9jF6U-Btx0alvvJuSU6w",
      title: "English",
      content_link: null,
      text:null,
      sub_content:[{
        sub_content_img:"https://media-exp3.licdn.com/dms/image/C561BAQH4LyFb3wbhTQ/company-background_10000/0/1618029083220?e=2159024400&v=beta&t=8h_EoDvajis_B4NeJcoeX1e9jF6U-Btx0alvvJuSU6w",
        text:"aaabbbcccdddeeefffggghhh"
      }]
    },
    cn: {
      banner_img: null,
      title: "China",
      content_link: null,
      text:null,
      sub_content:[{
        sub_content_img:null,
        text:null
      }],

  isPublish:"share",// share|on_schedule
  year:new Date().getFullYear()
  },
};
